import { Company } from 'module/api/company/types';
import { PeopleListRow } from 'api/account-people/types';
import { useAccountPeopleV2Query } from 'queries/account-people';
import { useCallback, useMemo } from 'react';
import { useExternalTeamMemberRoleField } from '../utils/use-external-team-member-role-field';
import { noRoleId } from '../utils/use-page-params';

type Props = {
  company: Company;
  role: number;
};

export const usePeopleByRole = ({ company, role }: Props) => {
  const { data: peopleList, isLoading: isPeopleListLoading } =
    useAccountPeopleV2Query(company.companyId);
  const { field: roleField } = useExternalTeamMemberRoleField();
  const roleFilterFunction = useCallback(
    (data: PeopleListRow) => {
      if (role === noRoleId) {
        return true;
      }

      return (
        data.user.fields?.find((field) => field.fieldId === roleField?.fieldId)
          ?.fieldValue === role
      );
    },
    [role, roleField?.fieldId],
  );
  const people = useMemo(() => {
    return peopleList?.pages.filter(roleFilterFunction) ?? [];
  }, [peopleList, roleFilterFunction]);
  const lastMeetingParticipants = useMemo(() => {
    return (
      peopleList?.latestMeetingParticipantPages.filter(roleFilterFunction) ?? []
    );
  }, [peopleList, roleFilterFunction]);

  return {
    lastMeetingParticipants,
    allPeople: peopleList?.pages ?? [],
    people,
    isLoading: isPeopleListLoading,
  };
};
